import { PaymentMethod } from '../enums';
import { getPaymentMethodsSetToDisable } from './get-payment-methods-set-to-disable.util';
import { isDuringDisablePeriod } from './is-during-disable-period.util';

export function getCurrentDisabledPaymentMethods(): PaymentMethod[] {
    if (!isDuringDisablePeriod()) return [] as PaymentMethod[];
    return getPaymentMethodsSetToDisable();
}
